import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { DropDown } from "../../Common";
import { Icon } from "../../Common/Icon";

export default class DropdownHeaderCell extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    dropdownItems: PropTypes.array,
    keyName: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    sortDirection: PropTypes.string,
    sortedColumn: PropTypes.string
  };

  static defaultProps = {
    className: "",
    dropdownItems: [],
    keyName: "",
    label: "",
    onClick: null,
    sortDirection: "",
    sortedColumn: ""
  };

  state = {
    isDropdownOpen: false
  };

  componentDidMount() {
    document.body.addEventListener("click", this.closeDropdowns);
  }

  componentWillUnmount() {
    document.body.removeEventListener("click", this.closeDropdowns);
  }

  get iconClassNames() {
    return classNames(
      "sorted-list__header-icon",
      this.props.sortedColumn === this.props.keyName && "--sorted",
      this.props.sortDirection === "desc" && "--desc"
    );
  }

  get contentClassNames() {
    return classNames(this.props.className, "sorted-list__header --dropdown");
  }

  closeDropdowns = () => this.setState({ isDropdownOpen: false });

  handleToggleHeaderDropdown = e => {
    e.stopPropagation();
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
  };

  handleClick = e => {
    e.stopPropagation();
    this.props.onClick(this.props.keyName);
  };

  render() {
    return (
      <div role="columnheader" tabIndex="0" className={classNames("sorted-list__header --dropdown-header", this.props.className)}>
        <span role="presentation" className="sorted-list__header-label --green" onClick={this.handleClick}>
          {this.props.label}
          <Icon className={this.iconClassNames} id="ic_arrow" />
        </span>
        <div role="presentation" className="sorted-list__header-dropdown" onClick={this.handleToggleHeaderDropdown}>
          <a className="sorted-list__arrow">
            <Icon id="arrow-down" />
          </a>
          <DropDown className="sorted-list__dropdown" contentTag="menu" isOpen={this.state.isDropdownOpen}>
            {this.props.dropdownItems.map(dropdownItem => (
              <li key={dropdownItem.label}>
                <a role="presentation" className="sorted-list__header-dropdown-link" onClick={dropdownItem.onClick}>
                  {dropdownItem.label}
                </a>
              </li>
            ))}
          </DropDown>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/DropdownHeaderCell.js